import { Component, OnInit, Input, Output, TemplateRef, ElementRef, EventEmitter, ViewChild } from '@angular/core';
import { ButtonModel } from '../../models/button/button.model';
import { TabsCardModel } from '../../models/tabs/tabs-card.model';
import { TabsCardStylingModel } from '../../models/tabs/tabs-card-styling.model';
import { TabsCardTemplates } from '../../templates/tabs-card.template';
import { CfCoreComponent } from '../core/core.component';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>Tabs Card component based on Angular Material Tabs</p>
 * <p>Example of using:</p>
 * <pre>
 * <code><</code>cf-tabs-card<code>></code><code><</code><code>/</code>cf-tabs-card<code>></code>
 * </pre>
 */
export class CfTabsCardComponent extends CfCoreComponent implements OnInit {
/**
 * <p>Example of model:</p>
 * <pre>{{'{'}}
 *  label: 'Card label'
 * {{'}'}}</pre>
 * <h4>label: string</h4>
 * Card label text
 */
properties: TabsCardModel;
/**
 * Object for all styling properties:
 * <h4>container: StylingModel</h4>
 * Styling properties for main container
 * <h4>label: StylingModel</h4>
 * Styling properties for card label
 * <h4>iconIndex: StylingModel</h4>
 * Styling properties for card index icon
 * <h4>prefixIndex: StylingModel</h4>
 * Styling properties for card index prefix
 */
styling: TabsCardStylingModel;
/**
 * Card label text
 * @param {?} value
 * @return {?}
 */
set label(value: string) { this.properties.label = value; }
/**
 * @hidden
 */
cardHeader;
/**
 * @hidden
 */
cardContent;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new TabsCardModel();
    this.styling = new TabsCardStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('tabs-card', TabsCardTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'TAB-CARD').then( sampler => {
        // console.log('TAB-CARD', this.id, this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-tabs-card',
  template: "<ng-template #cardHeader><ng-content select=\"[header]\"></ng-content></ng-template> <ng-template #cardContent><ng-content select=\"[content]\"></ng-content></ng-template>",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'label': [{ type: Input, args: ['label', ] },],
'cardHeader': [{ type: ViewChild, args: ['cardHeader', ] },],
'cardContent': [{ type: ViewChild, args: ['cardContent', ] },],
};
}

function CfTabsCardComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfTabsCardComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfTabsCardComponent.ctorParameters;
/** @type {?} */
CfTabsCardComponent.propDecorators;
/**
 * <p>Example of model:</p>
 * <pre>{{'{'}}
 *  label: 'Card label'
 * {{'}'}}</pre>
 * <h4>label: string</h4>
 * Card label text
 * @type {?}
 */
CfTabsCardComponent.prototype.properties;
/**
 * Object for all styling properties:
 * <h4>container: StylingModel</h4>
 * Styling properties for main container
 * <h4>label: StylingModel</h4>
 * Styling properties for card label
 * <h4>iconIndex: StylingModel</h4>
 * Styling properties for card index icon
 * <h4>prefixIndex: StylingModel</h4>
 * Styling properties for card index prefix
 * @type {?}
 */
CfTabsCardComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfTabsCardComponent.prototype.cardHeader;
/**
 * @hidden
 * @type {?}
 */
CfTabsCardComponent.prototype.cardContent;
/**
 * @hidden
 * @type {?}
 */
CfTabsCardComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
